import { TrainerGroupApi, trainersApi } from "api/trainers/trainersApi";
import { useEffect, useState } from "react";

export const useTrainerGroup = (trainerGroupId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<TrainerGroupApi | null>(null);

  useEffect(() => {
    const fetchTrainer = async () => {
      if (!trainerGroupId) {
        console.error("Trainer id not found.");
        setLoading(false);
        return;
      }
      const res = await trainersApi.fetchGroupById(trainerGroupId);
      try {
        setData(res.data);
      } catch (error) {
        // Handle error appropriately, perhaps with another state variable
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchTrainer();
  }, [trainerGroupId]);

  return { loading, data };
};
